
export let pageJumpMixin = {
  methods: {
    jumpToPlayerPage (playerId) {
      if (parseInt(this.$route.params.playerId) !== playerId) {
        this.$router.push({ name: 'basketball-player-info', params: { playerId: playerId.toString() } })
      }
    },
    jumpToTeamPage (teamId) {
      if (parseInt(this.$route.params.teamId) !== teamId) {
        this.$router.push({ name: 'basketball-team-fixture', params: { teamId: teamId.toString() } })
      }
    },
    jumpToNativeMatchPage (matchId, tabIndex) {
      if (!matchId) {
        console.log('matchId not existed')
        return
      }

      const u = navigator.userAgent
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (isiOS) {
        // iOS
        let jsonprc = {
          jsonrpc: 2.0,
          method: 'openCustomScheme',
          params: `sevenmmobile://%7b%22__cls__%22%3a%22SMMatchDetailViewController%22%2c%22sportType%22%3a2%2c%22matchID%22%3a${matchId}%2c%22defaultTopIndex%22%3a${tabIndex}%7d`
        }
        window.webkit.messageHandlers.nativeCallBack.postMessage(jsonprc)
      } else {
        // Android
        let params = {
          jumpUrl: `sevenmmobile://com.sevenm.view.singlegame.SingleGame?mId=${matchId}&kindNeed=1&tabFir=${tabIndex}`
        }
        console.log(`sevenmmobile://com.sevenm.view.singlegame.SingleGame?mId=${matchId}&kindNeed=1&tabFir=${tabIndex}`)
        window.JsPhone.jumpPageUrl(JSON.stringify(params))
      }
    }
  }
}
